// firebase
import { collection, setDoc, doc } from "firebase/firestore";
import { db } from "config/firebase";

// user-controller
import addSignature from "user-controller/addSignature";

// A ---------------------------------------------------------------------- M

const sendDataStreamInfo = async (isPublic, userID, dataBody, dataCertification, timestamp, databoxID) => {
  try {
    const txid = dataCertification.txid;
    const recordRef = doc(db, "recordsdata", txid);

    const recordData = {
      txid,
      type: "info",
      ...(databoxID && { tdr: databoxID }),
      creator_uuid: userID,
      public: isPublic,
      version: 1,
      timestamp,
      text: dataBody.text,
      data: {
        text: dataBody.text,
        timestamp,
      },
    };

    console.log(recordData);

    await setDoc(recordRef, recordData);

    if (databoxID) {
      const tagRef = doc(db, "tagsdata", databoxID);
      const recordsRef = collection(tagRef, "signatures");

      const signatureData = {
        txid,
        type: "info",
        creator_uuid: userID,
        public: isPublic,
        db_id: 1,
        timestamp,
        text: dataBody.text,
      };

      console.log(signatureData);
      await setDoc(doc(recordsRef, txid), signatureData);
    }

    databoxID ? await addSignature(userID, txid, timestamp, "info", databoxID) : await addSignature(userID, txid, timestamp, "info");

    const result = {
      txid: txid,
      success: true,
    };

    console.log(result);
    return result;
  } catch (error) {
    console.error("Error in sendDataStreamInfo:", error);

    const result = {
      success: false,
      error: error.message,
    };

    return result;
  }
};

export default sendDataStreamInfo;
